import { apiGet, apiPatch, apiPost } from '../../config/api';

export async function doctorSignup(body) {
  return apiPost('/api/doctor/signup', body);
}

export async function doctorLogin(body) {
  return apiPost('/api/doctor/login', body);
}

export async function doctorMe() {
  return apiGet('/api/doctor/me');
}

export async function doctorUpdateMe(body) {
  return apiPatch('/api/doctor/me', body);
}

export async function doctorChangePassword(body) {
  return apiPost('/api/doctor/change-password', body);
}

export async function doctorListPatients(q = '') {
  const qs = q ? `?q=${encodeURIComponent(q)}` : '';
  return apiGet(`/api/doctor/patients${qs}`);
}

export async function doctorCreatePatient(body) {
  return apiPost('/api/doctor/patients', body);
}

export async function doctorGetPatient(id) {
  return apiGet(`/api/doctor/patients/${id}`);
}

export async function doctorUpdatePatient(id, body) {
  return apiPatch(`/api/doctor/patients/${id}`, body);
}

export async function doctorPatientNotes(id, { status, limit } = {}) {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  if (limit != null) params.set('limit', String(limit));
  const qs = params.toString() ? `?${params}` : '';
  return apiGet(`/api/doctor/patients/${id}/notes${qs}`);
}

export async function doctorDashboardStats() {
  return apiGet('/api/doctor/dashboard/stats');
}

export async function doctorListNotes({ noteType, q, date } = {}) {
  const params = new URLSearchParams();
  if (noteType && noteType !== 'all') params.set('note_type', noteType);
  if (q) params.set('q', q);
  if (date) params.set('date', date);
  const qs = params.toString() ? `?${params}` : '';
  return apiGet(`/api/doctor/notes${qs}`);
}

export async function doctorGetNote(id) {
  return apiGet(`/api/doctor/notes/${id}`);
}

export async function doctorCreateNote(body) {
  return apiPost('/api/doctor/notes', body);
}

export async function doctorApproveNote(id, body = {}) {
  return apiPost(`/api/doctor/notes/${id}/approve`, body);
}

export async function doctorPatchNote(id, body) {
  return apiPatch(`/api/doctor/notes/${id}`, body);
}

export async function doctorStartSubscription(plan) {
  return apiPost('/api/doctor/subscriptions/start', { plan });
}

export async function doctorCancelSubscription(reason) {
  return apiPost('/api/doctor/subscriptions/cancel', { reason });
}

export async function doctorMarkDocumentDownloaded(id) {
  return apiPost(`/api/doctor/documents/${id}/downloaded`, {});
}

export async function doctorMarkDocumentPrinted(id) {
  return apiPost(`/api/doctor/documents/${id}/printed`, {});
}

export async function doctorSubmitFeedback({ rating, text = '', milestone = null }) {
  return apiPost('/api/doctor/feedback', { rating, text, milestone });
}
